import { render, staticRenderFns } from "./Land.vue?vue&type=template&id=51f98b76"
import script from "./Land.vue?vue&type=script&lang=ts"
export * from "./Land.vue?vue&type=script&lang=ts"
import style0 from "./Land.vue?vue&type=style&index=0&id=51f98b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports